import { DateTime } from 'luxon';
import { DatePicker, Icon, PrimaryButton, Text } from 'office-ui-fabric-react';
import React from 'react';
import { DateCustom } from '../../../lib/DateCustom';
import MessageCourier from '../../../lib/MessageCourier';
import TimeTaxSupportSystemClient from '../../../system';
import { CollaboratorViewDetailList } from './CollaboratorViewDetailList';
import { useTranslation } from 'react-i18next';
import { getLocalizedStrings } from '../../../lib/LocalizedStringsForDatePicker';
import { ICollaboratorDetailList } from '../../../system/panel/PanelSystem';
import ProjectTableExporter from '../../Panel/ExcelExport/ProjectTableExporter';
import { User } from '../../../system/User';
import PanelVerticalStackedBarChart from '../../Panel/PanelCollaborators/PanelVerticalStackedBarChart';

interface ICollaboratorPanelsProps {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (change: boolean) => void;
  from?: string | null | undefined;
  to?: string | null | undefined;
  colId?: string;
  user: User;
}

const CollaboratorPanels = (props: ICollaboratorPanelsProps) => {
  const { t, i18n } = useTranslation();

  const [fromDate, setFromDate] = React.useState<DateTime>(
      DateTime.fromJSDate(DateCustom.getFirstDayOfThisMonth())
  );
  const [toDate, setToDate] = React.useState<DateTime>(DateTime.fromJSDate(new Date()));
  const [loadDataTrigger, setLoadDataTrigger] = React.useState(0);
  const [projectPanel, setProjectPanel] = React.useState<any>([]);

  React.useEffect(() => {
    if (props.from) {
      let from = new Date(props.from);
      setFromDate(DateTime.fromJSDate(from));
    }
    if (props.to) {
      let to = new Date(props.to);
      setToDate(DateTime.fromJSDate(to));
    }
  }, [props.from, props.to]);

  const onChangeDate = (date: Date | null | undefined, name: string) => {
    if (date) {
      if (name === 'from') {
        setFromDate(DateTime.fromJSDate(date));
      }
      if (name === 'to') {
        setToDate(DateTime.fromJSDate(date));
      }
    }
  };

  const exportCollaboratorsComparison = (comparison: ICollaboratorDetailList[]) => {
    ProjectTableExporter.exportFor(comparison);
  };

  const handleGetProjects = async () => {
    const projectPanel = await props.system.getPanelSystem().getMyPlanProjectData(fromDate, toDate, props.colId || props.user.getCollaboratorId());
    setProjectPanel(projectPanel);
    setLoadDataTrigger((prev) => prev + 1);
  }

  return (
    <div>
      <div className="ms-Grid-row mt-1">
        <div className="ms-Grid-col ms-sm3 ">
          <DatePicker
            strings={getLocalizedStrings()}
            label={t("Filtrar desde")}
            formatDate={DateCustom.formatDate}
            value={fromDate ? fromDate.toJSDate() : undefined}
            onSelectDate={(e) => onChangeDate(e, "from")}
            className=""
            maxDate={toDate.toJSDate()}
          />
        </div>
        <div className="ms-Grid-col ms-sm3 ">
          <DatePicker
            strings={getLocalizedStrings()}
            label={t("Filtrar hasta")}
            formatDate={DateCustom.formatDate}
            value={toDate ? toDate.toJSDate() : undefined}
            onSelectDate={(e) => onChangeDate(e, "to")}
            className=""
          />
        </div>
        <div className="ms-Grid-col ms-sm3 ">
          <PrimaryButton
            iconProps={{ iconName: "Search" }}
            className="mt-for-btn-search ml-2"
            onClick={() => handleGetProjects()}
            text={t("Buscar")}
          />
        </div>
      </div>
      <hr />

      {loadDataTrigger > 0 ? (
        <>
          <div
            className="ms-Grid-row mt-1 mb-1"
            style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
          >
            <div className="ms-Grid-col ms-xl6 ms-lg12 ms-sm12">
              {projectPanel && (
                <PanelVerticalStackedBarChart
                  data={projectPanel}
                  user={props.user}
                />
              )}
            </div>
          </div>
          <hr></hr>
          {(props.user.isAdminUser() || props.user.isPowerUser()) && (
            <>
              <div className="ms-Grid-row mt-5">
                <PrimaryButton
                  iconProps={{ iconName: "ExcelLogo" }}
                  className="float-right ml-2"
                  onClick={() => exportCollaboratorsComparison(projectPanel?.projects || [])}
                >
                  {t("Exportar")}
                </PrimaryButton>
              </div>
              <div className="mt-2">
                {(projectPanel?.projects ?? []).length > 0 ? (
                  <div className="mt-5 bg-white-h100">
                    <CollaboratorViewDetailList data={projectPanel?.projects ?? []} />
                  </div>
                ) : (
                  <div className="text-center mt-2">
                    <Text variant="medium" className="fw-500">
                      <Icon iconName="AddGroup" className="text-icon"></Icon>
                      {t(
                        "No hay horas registradas en areas para los filtros seleccionados"
                      )}
                    </Text>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      ) : null}

    </div>
  );
};

export default CollaboratorPanels;
